import React, { createContext } from 'react';

interface NextStepNavigationContextValue {
  handleNextStep: (() => void) | null;
  ensureInProgress: () => Promise<void>;
}

const NextStepNavigationContext = createContext<NextStepNavigationContextValue>({
  handleNextStep: null,
  ensureInProgress: () => Promise.resolve()
});

const NextStepNavigationContextProvider: React.FC<
  React.PropsWithChildren<{ value: NextStepNavigationContextValue }>
> = ({ value, children }) => {
  return (
    <NextStepNavigationContext.Provider value={value}>
      {children}
    </NextStepNavigationContext.Provider>
  );
};

export default NextStepNavigationContext;
export { NextStepNavigationContextProvider };
